import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import EventEmitter from '@/libs/EventEmitter';

const useWaitingRobotTimer = (robotId, timeout = 5000) => {
  const heartbeat = useSelector((state) => state.telemetry[robotId]?.heartbeat);
  const droneOsd = useSelector((state) => state.telemetry[robotId]?.droneOsd);
  const dockOsdStatus = useSelector((state) => state.telemetry[robotId]?.dockOsdStatus);
  const robotStatus = useSelector((state) => state.robotStatus[robotId]);

  useEffect(() => {
    const waitingTimer = setTimeout(() => {
      EventEmitter.publish(`${robotId}/event/waitingRobot`);
    }, timeout);

    // 10분 후 연결 해제
    const disconnectTimer = setTimeout(() => {
      EventEmitter.publish(`${robotId}/event/disconnectRobot`);
    }, 600 * 1000);

    return () => {
      EventEmitter.publish(`${robotId}/event/reconnectRobot`);
      clearTimeout(waitingTimer);
      clearTimeout(disconnectTimer);
    };
  }, [heartbeat, droneOsd, dockOsdStatus, robotStatus]);
};

export default useWaitingRobotTimer;
